import axios from 'axios';
import { API_URL } from '../../@jumbo/constants/AppConstants';

export const FETCH_AGENTI_START = 'FETCH_AGENTI_START';
export const FETCH_AGENTI_SUCCESS = 'FETCH_AGENTI_SUCCESS';
export const FETCH_AGENTI_FAILURE = 'FETCH_AGENTI_FAILURE';

export const SAVE_AGENTE_START = 'SAVE_AGENTE_START';
export const SAVE_AGENTE_SUCCESS = 'SAVE_AGENTE_SUCCESS';
export const SAVE_AGENTE_FAILURE = 'SAVE_AGENTE_FAILURE';

export const DELETE_AGENTE_START = 'DELETE_AGENTE_START';
export const DELETE_AGENTE_SUCCESS = 'DELETE_AGENTE_SUCCESS';
export const DELETE_AGENTE_FAILURE = 'DELETE_AGENTE_FAILURE';

export const fetchAgenti = () => {
  return dispatch => {
    dispatch({ type: FETCH_AGENTI_START });

    axios
      .get(`${API_URL}/getAgenti.php`)
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: FETCH_AGENTI_SUCCESS,
            payload: response.data.data,
          });
        } else {
          dispatch({
            type: FETCH_AGENTI_FAILURE,
            payload: response.data.error || 'Errore nel caricamento agenti',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_AGENTI_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const saveAgente = agenteData => {
  return dispatch => {
    dispatch({ type: SAVE_AGENTE_START });

    const endpoint = agenteData.id ? 'updateAgente.php' : 'addNewAgente.php';

    axios
      .post(`${API_URL}/${endpoint}`, agenteData)
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: SAVE_AGENTE_SUCCESS,
            payload: response.data,
          });
          dispatch(fetchAgenti());
        } else {
          dispatch({
            type: SAVE_AGENTE_FAILURE,
            payload: response.data.error || 'Errore nel salvataggio agente',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: SAVE_AGENTE_FAILURE,
          payload: error.message,
        });
      });
  };
};

export const deleteAgente = id => {
  return dispatch => {
    dispatch({ type: DELETE_AGENTE_START });

    axios
      .post(`${API_URL}/eliminaAgente.php`, { id })
      .then(response => {
        if (response.data.success) {
          dispatch({
            type: DELETE_AGENTE_SUCCESS,
            payload: id,
          });
          dispatch(fetchAgenti());
        } else {
          dispatch({
            type: DELETE_AGENTE_FAILURE,
            payload: response.data.error || 'Errore nella cancellazione agente',
          });
        }
      })
      .catch(error => {
        dispatch({
          type: DELETE_AGENTE_FAILURE,
          payload: error.message,
        });
      });
  };
};
